<template>
  <v-container fill-height>

    <v-btn
      bottom
      fixed
      depressed
      text
      x-small
      right
      v-on:click="copy_version_number()"
    >
      {{ version_number }}</v-btn
    >
  </v-container>
</template>

<script>
import version from "../version";
export default {
  name: "Settings",
  components: {
  },
  computed: {
    version_number() {
      return version;
    }
  },
  methods: {
    copy_version_number() {
      navigator.clipboard.writeText(this.version_number);
    }
  },
};
</script>

<style scoped></style>
